import {
  Directive,
  HostListener,
  Input,
  Optional,
  Self
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[quantityInput]'
})
export class QuantityInputDirective {
  @Input() min: number;
  @Input() max: number;

  constructor (
    @Optional() @Self()
    private ngModel: NgModel
  ) {}

  @HostListener('input', [ '$event.target.value' ])
  onInput ( viewValue : string ) : void {
    if ( !this.ngModel ) return;

    const value    = parseFloat(viewValue);
    const minValue = parseFloat(String(this.min));
    const maxValue = parseFloat(String(this.max));

    if ( !isNaN(minValue) && value && value < minValue ) {
      this.ngModel.viewToModelUpdate(null);

      return;
    }

    if ( !isNaN(maxValue) && value && value > maxValue ) {
      this.ngModel.viewToModelUpdate(null);

      return;
    }

    this.ngModel.viewToModelUpdate(value ? this.round(value) : 0);
  }

  private round ( num : number ) : number {
    return Math.round(num * 100) / 100;
  }
}
